import { Component, Input } from "@angular/core";
import { BoardMember } from "../models/board-member";

@Component({
  selector: "appc-profile-picture",
  templateUrl: "./profile-picture.component.html",
  styleUrl: "./profile-picture.component.scss",
  standalone: false,
})
export class ProfilePictureComponent {
  @Input() boardMember : BoardMember;

  public get profilePicture () {
    if (this.boardMember.profilePicture) {
      return this.boardMember.profilePicture;
    }
    
    return false;
  }

  public get initials () {
    const initialsFirstName = this.boardMember.firstName === null || this.boardMember.firstName.length === 0 ? '' : this.boardMember.firstName[0];
    const initialsLastName = this.boardMember.lastName === null || this.boardMember.lastName.length === 0 ? '' : this.boardMember.lastName[0];

    return initialsFirstName + initialsLastName;
  }
}
